import React, { useState } from 'react';
import MiniAppForm from '../../components/MiniAppForm';
import './index.css';

const SubmitMiniAppPage = () => {
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const apiUrl = process.env.REACT_APP_API_URL
    
    const handleSubmit = async (data) => {
        setLoading(true);
        const userId = localStorage.getItem('telegram_user_id');
        console.log('Submitting form with userId:', userId);

        try {
            data.append('user', userId);

            const response = await fetch(`${apiUrl}apps/telegram-miniapps/`, {
                method: 'POST',
                body: data,
            });

            if (response.ok) {
                setMessage('Your mini app has been submitted for moderation.');
                setError('');
            } else {
                const errorData = await response.json();
                setMessage('');
                setError('Failed to submit your mini app. Please check your input.');
                console.error('Error:', errorData);
            }
        } catch (err) {
            console.error('Error:', err);
            setMessage('');
            setError('An error occurred while submitting your mini app.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="submit-mini-app-page">
            <h1>Submit Your Telegram Mini App</h1>
            {loading && <div className="loading-message">Submitting...</div>}
            {message && <div className="success-message">{message}</div>}
            {error && <div className="error-message">{error}</div>}
            <MiniAppForm onSubmit={handleSubmit} />
        </div>
    );
};

export default SubmitMiniAppPage;
